"use client";
import { BlurImage, FallBackImg } from "image-config";
import Image, { ImageProps } from "next/image";
import { useEffect, useRef, useState, startTransition } from "react";

type CustomImageProps = Omit<ImageProps, "src"> & {
  src: string;
  alt?: string;
};

const CustomImage = ({ alt, src, className, ...props }: CustomImageProps) => {
  const [error, setError] = useState<boolean>(false);
  const prevSrcRef = useRef<string>(src);

  useEffect(() => {
    if (prevSrcRef.current !== src) {
      prevSrcRef.current = src;
      startTransition(() => {
        setError((prevError) => (prevError ? false : prevError));
      });
    }
  }, [src]);

  // Filter out props that shouldn't be passed to the DOM
  const { blurDataURL, ...imageProps } = props;

  return (
    <Image
      className={className || "object-fill"}
      alt={alt || "image"}
      onError={() => setError(true)}
      src={error ? FallBackImg : src}
      loading="lazy"
      placeholder="blur"
      blurDataURL={BlurImage}
      {...imageProps}
    />
  );
};

export default CustomImage;
